import actions from "./actions"
import getters from "./getters"
import mutations from "./mutations"

const state = {
  currentModule: "",
  loader: false,
  drawerOpen: true,
  alert: {
    message: "",
    type: null,
    show: false
  },
  axiosHideLoader: false,
  tenant: {},
  tenantOrganisation: {},
  newVersionSnackbar: false,
  routeCount: 0,
  versionCheck: false,
  changeLogNewVersion: false,
}

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
}
